/**
 * @generated SignedSource<<29e3b0978beee6ee8cea846d21e2d437>>
 * @relayHash 01525025ed4d8bb38399335bb5d772ba
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/571.0.0-2026-08-05T18:04:07.735Z/FollowButtonRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FollowButtonRefetchQuery$variables = {
  followSearchUriRef: string;
  hasUserId: boolean;
  userId: string;
};
export type FollowButtonRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"FollowButton_viewer">;
  };
};
export type FollowButtonRefetchQuery = {
  response: FollowButtonRefetchQuery$data;
  variables: FollowButtonRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchUriRef"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FollowButtonRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "followSearchUriRef",
                "variableName": "followSearchUriRef"
              },
              {
                "kind": "Variable",
                "name": "hasUserId",
                "variableName": "hasUserId"
              },
              (v3/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "FollowButton_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "FollowButtonRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v3/*:: as any*/)
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      },
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "pages.0",
                            "variableName": "followSearchUriRef"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "pages"
                      },
                      {
                        "kind": "Literal",
                        "name": "types",
                        "value": [
                          "SEARCH"
                        ]
                      }
                    ],
                    "concreteType": "favoritesConnection",
                    "kind": "LinkedField",
                    "name": "favorites",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "favoritesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Favorite",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "serviceId",
                                "storageKey": null
                              },
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/571.0.0-2026-08-05T18:04:07.735Z/FollowButtonRefetchQuery",
    "metadata": {},
    "name": "FollowButtonRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "95c95d930521c6d031c53200ce13d362";

export default node;
